// Modified copy of /App_Plugins/formulate/templates/responsive.plain-javascript/utils/field.js
// Only edits are to set the idCount to 100, and to re-point require paths.

let FcbtFieldIdCount = 100; // Custom fields get assigened a separate sequence for id.
// Dependencies.
let AddClasses = require("/App_Plugins/formulate/templates/responsive.plain-javascript/utils/add-classes");

function FcbtField() {
}

FcbtField.initializeFieldPrototype = function (fieldPrototype) {

    // Use a fallback for setData?
    if (!fieldPrototype.setData) {
        fieldPrototype.setData = function () {};
    }

    // Use a fallback for checkValidity?
    if (!fieldPrototype.checkValidity) {
        fieldPrototype.checkValidity = function () {
            return [];
        };
    }

    // Use fallback for getCategory?
    if (!fieldPrototype.getCategory) {
        fieldPrototype.getCategory = function () {
            return null;
        };
    }

};

FcbtField.setData = function (data, value, options, alias, id) {    
    // Adjust options.
    options = options || {};
    options.rawDataByAlias = options.rawDataByAlias || false;

    // Set data.
    if (options.rawDataByAlias) {
        if (alias) {
            data[alias] = value;
        }
    } else {
        data.append(id, value);
    }

};

FcbtField.initializeField = function (fieldRenderer, fieldData, fieldValidators, options) {
    
    // Variables.
    let fieldElement, labelElement, fieldId, textNode, labelTextWrapper,
        useWrapper = options.useWrapper !== false,
        wrapperElement = options.wrapperElement,
        wrapperElementType = options.wrapperElementType || 'div',
        useLabel = options.useLabel !== false,
        labelText = options.hasOwnProperty("label")
            ? options.label
            : fieldData.label,
        hasLabel2 = options.hasOwnProperty("label2");

    // Create element.
    fieldElement = document.createElement(options.nodeName || "input");
    if (options.type) {
        try {
            fieldElement.type = options.type;
        } catch (ex) {

            // Fallback for IE11 (throws an error in some cases, such as when type="date").
            fieldElement.setAttribute("type", options.type);

        }
    }
    if (options.hasOwnProperty("name")) {
        fieldElement.name = options.name;
    }

    // Add the catagory to the field.
    if (fieldData.category) {
        fieldElement.setAttribute("data-category", fieldData.category);
    }

    // Set value?
    if (options.hasOwnProperty("value")) {
        fieldElement.value = options.value;
    }

    // Set aria label.
    if (useLabel) {
        fieldElement.setAttribute("aria-label", labelText);
    }

    // Create wrapper element, or just use the field element as the wrapper.
    wrapperElement = useWrapper
        ? (wrapperElement || document.createElement(wrapperElementType))
        : fieldElement;

    // Attach CSS classes.
    if (options.cssClasses) {
        AddClasses(wrapperElement, options.cssClasses);
    }
    AddClasses(wrapperElement, Object.keys(fieldValidators).map(function (x) {
        return "formulate__validation-type--" + x;
    }));

    // Add placeholder?
    if (options.usePlaceholder !== false) {
        fieldElement.setAttribute("placeholder", labelText);
    }

    // Create label element?
    if (useLabel) {
        fieldId = FcbtField.generateId("formulate-field-");
        fieldElement.setAttribute("id", fieldId);
        labelElement = document.createElement("label");
        labelElement.setAttribute("for", fieldId);
        labelElement.classList.add("formulate__field__label");
        textNode = document.createTextNode(labelText);
        if (options.wrapLabelText) {
            labelTextWrapper = document.createElement("span");
            labelTextWrapper.classList.add("formulate__field__label-text");
            labelTextWrapper.appendChild(textNode);
            labelElement.appendChild(labelTextWrapper);
            if (hasLabel2) {
                labelTextWrapper = labelTextWrapper.cloneNode();
                textNode = document.createTextNode(options.label2);
                labelTextWrapper.appendChild(textNode);
                labelElement.appendChild(labelTextWrapper);
            }
        } else {
            labelElement.appendChild(textNode);
        }
        wrapperElement.appendChild(labelElement);
    }

    // Add element to wrapper?
    if (useWrapper) {
        if (options.nestFieldInLabel) {
            if (options.fieldBeforeLabelText) {
                labelElement.insertBefore(fieldElement, labelElement.childNodes[0]);
            } else {
                labelElement.appendChild(fieldElement);
            }
        } else {
            if (options.fieldBeforeLabelText === false || window.labelAfterTextInput === false) {
                wrapperElement.appendChild(fieldElement);
            } else {
                wrapperElement.insertBefore(fieldElement, wrapperElement.childNodes[wrapperElement.childNodes.length - 1]);
            }
        }
    }

    // Retain DOM elements and field properties.
    if (useWrapper) {
        fieldRenderer.wrapper = wrapperElement;
    }
    fieldRenderer.element = fieldElement;
    fieldRenderer.id = fieldData.id;
    fieldRenderer.alias = fieldData.alias;
    fieldRenderer.label = labelElement;

    // Prepare the validators and retain them for later use.
    fieldRenderer.validators = require("/App_Plugins/formulate/templates/responsive.plain-javascript/utils/validation").prepareValidators(fieldData.validations, fieldValidators);

};

FcbtField.generateId = function (prefix) {
    FcbtFieldIdCount++;
    return prefix + FcbtFieldIdCount.toString();
};

// Export the form field utility functions.
module.exports = FcbtField;
